// extracted by mini-css-extract-plugin
export default {"body":"make-order_body__2-J73","total":"make-order_total__etcWz","totalText":"make-order_totalText__-n8Vp","info":"make-order_info__D-Gd+"};